export default __webpack_public_path__ + "media/images/new-white-logo-f40a0d30cb862beb8a1469da0e4436c5.svg";